// oxlint-disable-next-line no-restricted-imports -- a saved section names its icon ("Home", "CheckCircle"), so the lookup needs every export; the sparkles are swapped below
import * as LucideIcons from "lucide-react";

type IconsByName = Readonly<Record<string, LucideIcons.LucideIcon | undefined>>;

/** Every name lucide exports a sparkles icon under. Tim: never sparkles; our icon for what we did is Zap. */
const SPARKLES = /^(?:Lucide)?(?:Sparkles?|Stars|WandSparkles|Wand2)(?:Icon)?$/u,
  EXPORTS = LucideIcons as unknown as IconsByName,

  /**
   * Every lucide icon by the export name a saved section stores ("Home"). A
   * sparkles name draws the Zap bolt; the saved name itself is never rewritten.
   */
  LUCIDE_ICONS: IconsByName = Object.fromEntries(
    Object.entries(EXPORTS).map(([name, icon]) => [name, SPARKLES.test(name) ? LucideIcons.Zap : icon] as const),
  );

export { LUCIDE_ICONS };
